import { ExportExclusionsPanelController } from '../controller/ExportExclusionsPanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class ExportExclusionsPanelWebComponent extends BaseWebComponentElement {
  public controller!: ExportExclusionsPanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ExportExclusionsPanelController,
    });
  }
}
